import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CustomVendorReportingAdapter } from '../custom-vendor-reporting.adapter';
import {
  CustomVendorReportingOverviewList,
  VendorReportingDetailResponse,
  VendorReportingDetailResultsData,
  CustomRioDataEvaluationOverviewList
} from '../custom-vendor-reporting.models';
import * as CustomVendorReportingActions from './custom-vendor-reporting.action';

@Injectable()
export class CustomVendorReportingEffects {
  constructor(
    private actions$: Actions,
    private customVendorReportingAdapter: CustomVendorReportingAdapter
  ) {}

  getVendorReporting$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomVendorReportingActions.getVendorReportingOverview),
      switchMap((action) =>
        this.customVendorReportingAdapter
          .getVendorReporting(action.searchFilters)
          .pipe(
            map((vendorReportingOverview: CustomVendorReportingOverviewList) =>
              CustomVendorReportingActions.getVendorReportingOverviewSuccess({
                vendorReportingOverview,
              })
            ),
            catchError((error) =>
              of(
                CustomVendorReportingActions.getVendorReportingOverviewFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  getVendorReportingDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomVendorReportingActions.getVendorReportingDetails),
      switchMap((action) =>
        this.customVendorReportingAdapter
          .getVendorReportingDetails(action.reportTransferData)
          .pipe(
            map((vendorReportingDetails: VendorReportingDetailResponse) =>
              CustomVendorReportingActions.getVendorReportingDetailsSuccess({
                vendorReportingDetails,
              })
            ),
            catchError((error) =>
              of(
                CustomVendorReportingActions.getVendorReportingDetailsFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  updateVendorReportingDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomVendorReportingActions.updateVendorReportingDetails),
      switchMap((action) =>
        this.customVendorReportingAdapter
          .updateVendorReportDetailsData(
            action.reportTransferData,
            action.VendorReportingDetailsList
          )
          .pipe(
            map((messages) => {
              if (!messages || (messages && messages.length < 1)) {
                return CustomVendorReportingActions.updateVendorReportingDetailsSuccess();
              } else {
                return CustomVendorReportingActions.updateVendorReportingDetailsFailure(
                  { errorMessage: messages }
                );
              }
            }),
            catchError((messages: VendorReportingDetailResultsData[]) =>
              of(
                CustomVendorReportingActions.updateVendorReportingDetailsFailure(
                  { errorMessage: messages }
                )
              )
            )
          )
      )
    );
  });

  deleteVendorReportingDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomVendorReportingActions.deleteVendorReportingDetails),
      switchMap((action) =>
        this.customVendorReportingAdapter
          .deleteVendorReportDetailsData(
            action.reportTransferData,
            action.VendorReportingDetailsList
          )
          .pipe(
            map(() => {
              return CustomVendorReportingActions.deleteVendorReportingDetailsSuccess();
            }),
            catchError(() =>
              of(
                CustomVendorReportingActions.deleteVendorReportingDetailsFailure()
              )
            )
          )
      )
    );
  });


getRioDataEvaluation$ = createEffect(() => {
  return this.actions$.pipe(
    ofType(CustomVendorReportingActions.getRioDataEvaluationOverview),
    switchMap((action) =>
      this.customVendorReportingAdapter
        .getRioDataEvaluationOverviewData(action.searchFilters)
        .pipe(
          map((vendorReportingOverview:CustomRioDataEvaluationOverviewList ) =>
            CustomVendorReportingActions.getRioDataEvaluationOverviewSuccess({
              vendorReportingOverview,
            })
          ),
          catchError((error) =>
            of(
              CustomVendorReportingActions.getRioDataEvaluationOverviewFailure({
                error,
              })
            )
          )
        )
    )
  );
});
}
